import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import ShareIcon from '@material-ui/icons/Share';
import { CREATE_THREAD_LIKE_API } from 'src/Api/Community/Index';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { POST_CREATE_START,POST_CREATE_SUCCESS,POST_CREATE_FAIL } from 'src/slices/PostSlice';
import { isLikedThread } from 'src/utils/helper';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  likedButton: {
    color: colors.red[600]
  }
}));

const Reactions = ({ className, thread, ...rest }) => {
  // console.log(thread);
  const classes = useStyles();
  const {authData}=useSelector((state)=>state.authData);
  const [isLiked, setLiked] = useState(isLikedThread(thread.likes,authData.com_userId));
  const [likes, setLikes] = useState(thread.likes.length);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch=useDispatch();
  
  useEffect(() => {
    setLiked(isLikedThread(thread.likes,authData.com_userId))
    setLikes(thread.likes.length)
  }, [thread])

  
  const handleLike = async() => {
    try {
      if(!(authData && authData.com_userId)){
        enqueueSnackbar("To react to a thread please Register and Login.", {
          variant: 'error',
          anchorOrigin: { horizontal: "center", vertical: "top"}
        });
        return ;
      }
      const post_data={
        "userId":authData.com_userId
      }
      const {data}=await CREATE_THREAD_LIKE_API(post_data,thread._id)
      const {status,message,updateThread}=data;
      if(status){
        setLiked(!isLiked);
        if(isLiked){
          setLikes((prevLikes) => prevLikes - 1);
        }else{
          setLikes((prevLikes) => prevLikes + 1);
        }
        dispatch(POST_CREATE_SUCCESS(updateThread))
        enqueueSnackbar(message, {
          variant: 'success',
          anchorOrigin: { horizontal: "center", vertical: "top"}
        });
      }else{
        enqueueSnackbar(message, {
          variant: 'success',
          anchorOrigin: { horizontal: "center", vertical: "top"}
        });
      }
    } catch (error) {
      console.log(error); 
      enqueueSnackbar("Something went wrong.Try Later.!!", {
        variant: 'success',
        anchorOrigin: { horizontal: "center", vertical: "top"}
      });
    }
  };



  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      {isLiked ? (
        <Tooltip title="Unlike">
          <IconButton
            className={classes.likedButton}
            onClick={handleLike}
          >
            <FavoriteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Like">
          <IconButton onClick={handleLike}>
            <FavoriteBorderIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <Typography
        color="textSecondary"
        variant="h6"
      >
        {likes}
      </Typography>
      
    </div>
  );
};

Reactions.propTypes = {
  className: PropTypes.string,
  post: PropTypes.object.isRequired
};

export default Reactions;
